export const selectDiagnosticReportInfo = (state) => state.diagnosticReport.diagnosticReportInfo;
export const selectDiagnosticReportInfoLoading = (state) => state.diagnosticReport.diagnosticReportInfoLoading;

export const selectPublicHealthReportInfo = (state) => state.publicHealthReport.publicHealthReportInfo;
export const selectPublicHealthReportInfoLoading = (state) => state.publicHealthReport.publicHealthReportInfoLoading;
